



































































import {
    defineComponent,
    ref,
    computed,
} from '@vue/composition-api';
import { ValidationErrorTranslationKey } from '@superbet-group/web.types';
import {
    useVueRouter,
    useI18n,
} from '@superbet-group/web.lib.vue-utilities';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import {
    SdsButton,
    SdsIcon,
} from '@superbet-group/web.lib.ui-components';
import {
    isValidEmail,
    isRequired,
} from '@superbet-group/web.lib.utilities';
import {
    ResendEmailState,
    useResendEmail,
} from 'account/modules/registration/useResendEmail';

export default defineComponent({
    setup() {
        const email = ref<string>('');
        const errors = ref<any>(null);
        const isEmailValid = computed<boolean>(() => !!isValidEmail(email.value));

        const { route } = useVueRouter();

        const {
            isLoading,
            asyncError,
            emailState,
            resendActivationEmail,
        } = useResendEmail(true, 3);

        const { translate } = useI18n();

        function validate() {
            const validationErrors = isRequired(email.value) || isValidEmail(email.value);
            if (validationErrors) {
                errors.value = translate(
                    (validationErrors as ValidationErrorTranslationKey).translationKey,
                    (validationErrors as ValidationErrorTranslationKey).payload,
                );
                return null;
            } else {
                errors.value = null;
            }
        }

        function clearErrors() {
            errors.value = null;
        }

        function onResendEmail() {
            if (!errors.value) {
                resendActivationEmail(email.value, true);
            }
            AnalyticsSDK.getInstance().log('ResendActivationEmail', {
                email: email.value,
                errors: errors.value,
                hasExpiredLink: !!route.value.params.hasExpiredLink,
            });
        }

        return {
            email,
            errors,
            validate,
            isLoading,
            asyncError,
            clearErrors,
            isEmailValid,
            onResendEmail,
            isSuccess: computed(() => emailState.value === ResendEmailState.Sent),
            isTimeout: computed(() => emailState.value === ResendEmailState.Timeout),
        };
    },
    components: {
        SdsIcon,
        SdsButton,
    },
});
